import { ca } from '@cian/analytics';

import { getTermsValue, getTermValue, TJsonQuery } from '../../../packages/JsonQuery';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import {
  IPublicWebV1SearchResponse,
  TPublicWebV1SearchResponse_MlRanking,
} from '../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { TAnalyticsPageType } from '../utils/analytics';

const OFFERS_ON_PAGE = 28;

const trackingReasonToListingType = {
  pin_click: 'map',
  all_objects_on_map: 'list',
};

/** Событие выдачи №3 «Поисковая выдача» (newpage/open) */
export const trackListingOpen = (
  reason: 'all_objects_on_map' | 'pin_click',
  pageType: TAnalyticsPageType,
  pageNumber: number,
  offersCount: number | undefined,
  products: TListingProduct[],
  jsonQuery: IJsonQuery,
  mlSearchSessionGuid: string | null | undefined,
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined,
  queryString: string | null | undefined,
) => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      listingType: trackingReasonToListingType[reason],
      pageType,
      offersQty: offersCount ?? null,
      pageNumber,
      extra: {
        reason,
        mobileWebsiteType: 'new',
        mlSearchSessionGuid,
        mlRankingGuid: mlRanking?.guid,
        mlRankingModelVersion: mlRanking?.modelVersion,
        // Регион поиска - поле события №3 «Поисковая выдача»
        region: getTermsValue('region')(jsonQuery as TJsonQuery)?.[0],
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products,
    sc: jsonQuery,
  });
};

export type TListingProduct = {
  id: number;
  position: number;
  offerType: 'offer';
  extra?: {
    test_ota?: boolean;
    isPriceWithDiscount?: boolean;
  };
};

interface ITrackListingShowProps extends Omit<Partial<IPublicWebV1SearchResponse>, 'offers'> {
  offers: IPublicWebV1SearchResponse['offers'] | { id: number; discount?: number }[];
}

export const trackListingShow =
  (reason: 'all_objects_on_map' | 'pin_click') =>
  ({ offers, jsonQuery, mlRanking, queryString, offersCount, mlSearchSessionGuid }: ITrackListingShowProps) => {
    if (!offers?.length) {
      return;
    }

    const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;
    const offersPositionOffset = (pageNumber - 1) * OFFERS_ON_PAGE;
    const products = offers.reduce((acc, offer, index) => {
      const product: TListingProduct = {
        id: offer.id,
        position: index + 1 + offersPositionOffset,
        offerType: 'offer',
        extra: {
          isPriceWithDiscount: Boolean(offer.discount),
        },
      };

      return [...acc, product];
    }, []);

    trackListingOpen(
      reason,
      // Выдача списком мобвеба
      'Listing',
      pageNumber,
      offersCount,
      products,
      jsonQuery as TJsonQuery,
      mlSearchSessionGuid,
      mlRanking,
      queryString,
    );
  };
